import {
  BriefNotificationActionType,
  BriefNotificationStatusType,
} from "@shared/lib/types/brief";

const ACTION_TITLE_MAP: Record<BriefNotificationActionType, string> = {
  [BriefNotificationActionType.copyToAnotherBrief]:
    "Copy creators to another brief",
  [BriefNotificationActionType.declineBrand]: "Decline Creators",
  [BriefNotificationActionType.setCustomColumns]: "Custom columns",
  [BriefNotificationActionType.setCustomColumnsOnCampaignInfluencer]:
    "Custom columns",
  [BriefNotificationActionType.attachDeliverables]: "Deliverables attachment",
  [BriefNotificationActionType.purchase]: "Creator purchase",
  [BriefNotificationActionType.priceReachout]: "WhatsApp reach-out",
  [BriefNotificationActionType.priceReachoutResend]:
    "WhatsApp reach-out resend",
  [BriefNotificationActionType.analyzeCreator]: "Bulk AI analyze",
  [BriefNotificationActionType.reAnalyzeCreator]: "Bulk AI re-analyze",
  [BriefNotificationActionType.declineInfluencer]: "Decline Creators",
  [BriefNotificationActionType.assignPricingPoc]: "Assign Pricing POC",
  [BriefNotificationActionType.reallocatePricingPoc]: "Reallocate Pricing POC",
  [BriefNotificationActionType.removePricingPoc]: "Remove Pricing POC",
  [BriefNotificationActionType.deleteInfluencer]: "Delete Creators",
  [BriefNotificationActionType.addInfluencersToBucket]: "Add to Bucket",
  [BriefNotificationActionType.skipConfirmation]: "Skip Confirmation",
  [BriefNotificationActionType.resendConfirmation]: "Resend Confirmation",
  [BriefNotificationActionType.shortlist]: "Shortlist creators",
  [BriefNotificationActionType.unshortlist]: "Unshortlist creators",
  [BriefNotificationActionType.markPendingReviewAsSeen]: "Mark updates as seen",
  [BriefNotificationActionType.addSocialMediaToBrief]: "Add creators",
  [BriefNotificationActionType.editBriefInfluencer]: "Edit creators",
  [BriefNotificationActionType.attachBriefToCampaignInfluencerTask]:
    "Attach Brief",
  [BriefNotificationActionType.assignOperationsPocToCampaignInfluencer]:
    "Assign Operations POC ",
  [BriefNotificationActionType.editOrAddScriptToCampaignInfluencerTask]:
    "Attach Script",
  [BriefNotificationActionType.markPendingReviewAsSeenOnCampaignInfluencer]:
    "Mark updates as seen",
};

const ACTION_DESCRIPTION_MAP: Record<BriefNotificationActionType, string> = {
  [BriefNotificationActionType.copyToAnotherBrief]:
    "Copying selected creators to another brief",
  [BriefNotificationActionType.declineBrand]: "",
  [BriefNotificationActionType.setCustomColumns]:
    "Updating custom column configuration",
  [BriefNotificationActionType.setCustomColumnsOnCampaignInfluencer]:
    "Updating custom column configuration",
  [BriefNotificationActionType.attachDeliverables]:
    "Attaching deliverables to creators",
  [BriefNotificationActionType.purchase]:
    "Processing creator purchase for the campaign",
  [BriefNotificationActionType.priceReachout]:
    "Sending WhatsApp reach-out to selected creators",
  [BriefNotificationActionType.priceReachoutResend]:
    "Resending WhatsApp reach-out to selected creators",
  [BriefNotificationActionType.analyzeCreator]:
    "Running AI fit analysis on filtered creators",
  [BriefNotificationActionType.reAnalyzeCreator]:
    "Re-running AI fit analysis on filtered creators",
  [BriefNotificationActionType.declineInfluencer]: "",
  [BriefNotificationActionType.assignPricingPoc]: "Assigning Pricing POC",
  [BriefNotificationActionType.reallocatePricingPoc]:
    "Reallocating Pricing POC",
  [BriefNotificationActionType.removePricingPoc]: "Removing Pricing POC",
  [BriefNotificationActionType.deleteInfluencer]: "Deleting selected creators",
  [BriefNotificationActionType.addInfluencersToBucket]:
    "Adding creators to bucket",
  [BriefNotificationActionType.skipConfirmation]:
    "Skipping confirmation mail for selected creators",
  [BriefNotificationActionType.resendConfirmation]:
    "Resending confirmation mail to selected creators",
  [BriefNotificationActionType.shortlist]: "Shortlisting creators",
  [BriefNotificationActionType.unshortlist]: "Unshortlisting creators",
  [BriefNotificationActionType.markPendingReviewAsSeen]:
    "Marking pending review updates as seen",
  [BriefNotificationActionType.addSocialMediaToBrief]:
    "Adding creators from the sheet to this brief",
  [BriefNotificationActionType.editBriefInfluencer]:
    "Updating creators from the sheet on this brief",
  [BriefNotificationActionType.attachBriefToCampaignInfluencerTask]:
    "Adding brief to campaign influencer task",
  [BriefNotificationActionType.assignOperationsPocToCampaignInfluencer]:
    "Assigning Operations POC to campaign influencer task",
  [BriefNotificationActionType.editOrAddScriptToCampaignInfluencerTask]:
    "Adding script to campaign influencer task",
  [BriefNotificationActionType.markPendingReviewAsSeenOnCampaignInfluencer]:
    "Marking pending review updates as seen",
};

export function getNotificationActionTitle(
  action: BriefNotificationActionType
): string {
  return ACTION_TITLE_MAP[action] ?? action;
}

export function getNotificationActionDescription(
  action: BriefNotificationActionType
): string {
  return ACTION_DESCRIPTION_MAP[action] ?? getNotificationActionTitle(action);
}

export function getNotificationStatusLabel(
  status: BriefNotificationStatusType
): string {
  switch (status) {
    case BriefNotificationStatusType.Pending:
    case BriefNotificationStatusType.Processing:
      return "Processing…";
    case BriefNotificationStatusType.Completed:
      return "Completed";
    case BriefNotificationStatusType.Failed:
      return "Failed";
    case BriefNotificationStatusType.CompletedResolved:
    case BriefNotificationStatusType.FailedResolved:
      return "Resolved";
    default:
      return status ?? "—";
  }
}
